<template>
    <div class="">
        <div class="modal fade" id="loginMoblizer" tabindex="-1" role="dialog" aria-labelledby="loginMoblizerLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body login-mobilizer text-left p-4">
                        <div class="login-mobilizer-inner p-5">
                            <img class="logo mb-3" src="/banks/EASY_PAISA.png" alt="" />
                            <div class="moblizer-account-detail">
                                <label class="label block-label" v-if="paymentType === 'pms_membership_payment'"> Do you want to proceed ?</label>
                                <label class="label block-label" v-else> Do you want to proceed following batch ?</label>
                                <div class="row normal-ib-space mt-3">
                                    <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close" @click="cancelMobilizer"> Cancel </button> </div>
                                    <div class="col"> <button class="btn btn-primary active" @click="proceedLogin"> Proceed </button> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

    export default {
        props:['paymentType','payroll_id'],

        data() {
            return {
                processForm : new Form({
                    payroll_id     : this.payroll_id,
                    paymentReprocess : false
                }),
            };
        },
        mounted() {
            // EventBus.$on('paymentReprocess', data => {
            //    this.processForm.paymentReprocess = data;
            // });
        },
        methods:{
            proceedLogin: function(){ // pending
                this.$Progress.start();
                var url = '';
                if(this.paymentType == 'employee_payment'){
                    url = '/api/proceedBatchQueue';
                }else if(this.paymentType == 'pms_membership_payment'){
                    
                    this.showToastBox('success', 'Success');
                    this.$emit('corpLoginSuccess', {
                        bank: 'ep',
                        data: null
                    });

                    $('#loginMoblizer').modal('hide');
                    return true;
                }else{
                    url = '/api/VendorSendForPayment';
                }
                this.processForm.post(url)
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success',res.data.message);
                            $('#loginMoblizer').modal('hide');
                            if(this.paymentType == 'employee_payment'){
                                this.$router.push('/employeePayments');
                            }else{
                                this.$router.push('/vendorPayment');
                            }
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            cancelMobilizer: function(){
                $('#loginMoblizer').find('.moblizer-account-login').removeClass('hide');
                $('#loginMoblizer').find('.moblizer-account-detail').addClass('hide');
            },
        },
        destroyed: function() {
            // EventBus.$off('paymentReprocess');
        }

    }
</script>
